import React from "react";
import "../../../../App.css";
import "./HeroSection.css";
import ArticleGallery from "./ArticleGallery";

function HeroSection() {
  return <ArticleGallery />;
}

export default HeroSection;
